import { Shffl } from '../components/Shffl';
import { Basics, isTouch } from '../core/Basics';
import { GetBy } from '../core/Element';
import { Maths } from '../utils/Maths';
import { Ease } from '../utils/Ease';
import gsap, { Power2 } from 'gsap';

export default class ScrollbarCircle {
  container = null;
  digitFirst;
  digitSecond;
  vector;

  progress = 0;
  current = -1;
  total = 0;

  isShow = false;

  constructor(__container = GetBy.class('Scrollbar'), opts = {}) {
    this.container = __container;

    if (opts.total) this.total = opts.total;

    this.vector = GetBy.selector('svg', this.container)[0];

    const current = GetBy.class('__current', this.container)[0];
    this.digitFirst = GetBy.selector('span', current)[0];
    this.digitSecond = GetBy.selector('span', current)[1];
    gsap.set([this.digitFirst, this.digitSecond], { rotateY: '-100deg', opacity: 0 });

    this.update(0);
  }

  show() {
    const prog = { n: 0 };
    let delay = .5;

    gsap.to(prog, {
      n: 100,
      duration: .5,
      delay,
      ease: Power2.easeOut,
      onUpdate: () => {
        this.container.style.setProperty('--progress-track', prog.n);
      },
      onComplete: () => {
        this.isShow = true;
      }
    });
  }

  update(__progress) {
    this.progress = __progress;

    if (!this.isShow) return;

    let p = Maths.clamp(Math.ceil(__progress * 100), 0, 100);

    this.container.style.setProperty('--progress', p);

    const current = Maths.clamp(Math.floor(Maths.lerp(0, this.total, this.progress)), 0, this.total - 2);

    if (this.current !== current) {
      this.current = current;

      gsap.killTweensOf([this.digitFirst, this.digitSecond]);
      gsap.set([this.digitFirst, this.digitSecond], { rotateY: '-100deg', opacity: 0 });

      const temp = (current + '').padStart(2, '0');
      this.digitFirst.innerHTML = temp.split('')[0];
      this.digitSecond.innerHTML = temp.split('')[1];

      gsap.to(this.digitFirst, { rotateY: '0', duration: .6, ease: Power2.easeOut });
      gsap.to(this.digitFirst, { opacity: 1, duration: .2, delay: .1, ease: Power2.easeOut });

      gsap.to(this.digitSecond, { rotateY: '0', duration: .6 + .05, ease: Power2.easeOut });
      gsap.to(this.digitSecond, { opacity: 1, duration: .2, delay: .2, ease: Power2.easeOut });
    }

    const deg = Maths.lerp(0, 90, Maths.clamp(this.progress, 0, 1))
    gsap.set(this.vector, { rotateZ: deg + 'deg' })
  }

  end() {
    this.progress = 0;
  }

  resize() { }

  dispose() { }
}